import { render, staticRenderFns } from "./collapse-indicator.vue?vue&type=template&id=2cadb163"
import script from "./collapse-indicator.vue?vue&type=script&lang=js"
export * from "./collapse-indicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cadb163')) {
      api.createRecord('2cadb163', component.options)
    } else {
      api.reload('2cadb163', component.options)
    }
    module.hot.accept("./collapse-indicator.vue?vue&type=template&id=2cadb163", function () {
      api.rerender('2cadb163', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue-components/collapse-indicator.vue"
export default component.exports